import React, { Component } from 'react';

import { REST_API_URL } from "../../Utils/Global";

import Action from '../Helper/Grid/Action';
import Grid from '../Helper/Grid';
import GridFilter from '../Helper/GridFilter';

import Objectif from '../Entity/Objectif';

/**
* Class ObjectifList
* ObjectifList view component
**/
class ObjectifList extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClass = Objectif;

    // Filter list
    const filters = this.getFilters();

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer mes objectifs</h2>
        <GridFilter title="Filtrer les objectifs" objectClass={objectClass.getClassName()} filters={filters} parent={this} formattedFilters={true} />
        <Grid title="Objectifs" ref={"grid" + objectClass.name} path="objectifs" objectPath="objectifs" objectClass={objectClass} parent={this} height="400px" hidden={false}
          createActionsFunction={this.createActionsFunction} />
      </div>
		);
	}

  /**
  * createActionsFunction
  * Custom action creation function
  **/
  createActionsFunction(cell, row, opt) {
    const props = {
      object: row,
      objectClass: this.props.objectClass,
      parentGrid: this,
      fields: this.state.fields,
      mode: this.props.mode,
      isGeom: this.props.isGeom === true,
      withoutView: this.props.isGeom === true,
      withoutDelete: row.nbContrats > 0 || row.nbProjets > 0,
    };

    const component = <Action {...props}></Action>;
    return component;
  }

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs["grid" + Objectif.name];
    grid.applyFilter(fieldName, value);
  }

  /**
  * applyArrayFilter
  * Filters the grid
  **/
  applyArrayFilter(fieldName, value) {
    const grid = this.refs["grid" + Objectif.name];
    grid.applyArrayFilter(fieldName, value);
  }

  /**
  * applyDateFilter
  * Filters the grid
  **/
  applyDateFilter(filterField, dateValue, comparatorValue) {
    const grid = this.refs["grid" + Objectif.name];
    grid.applyDateFilter(filterField, dateValue, comparatorValue);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs["grid" + Objectif.name];
    grid.clearFilters();
  }

  /**
  * getFilters
  * Returns the filters
  **/
  getFilters() {
    return [{
      title: "Nom de l'objectif",
      type: "text",
      name: "libelle",
      rowIdx: 1
    },{
      title: "Concerne des...",
      type: "combo",
      name: "estContrat",
      dataSource: {collection: [{id: "true", name: "Occupations"}, {id: "false", name: "Projets"}]},
      rowIdx: 1
    },
    // {
    //   type: "map",
    //   layer: "objectif",
    //   name: "idObjectif",
    //   rowIdx: 1
    // }
    // ,
    {
      title: "Thématique",
      type: "combo",
      multi: true,
      isArray: true,
      name: "thematiques",
      optionValueKey: "idThematique",
      optionLabelKey: "libelle",
      url: REST_API_URL + "/thematiques/",
      rowIdx: 2
    },{
      title: "Mots-clé",
      type: "combo",
      multi: true,
      isArray: true,
      name: "motCles",
      optionValueKey: "idMotCle",
      optionLabelKey: "libelle",
      url: REST_API_URL + "/motcles/",
      rowIdx: 2
    },{
      title: "Donneurs d'ordre",
      type: "combo",
      isArray: true,
      name: "donneurOrdres",
      optionValueKey: "idDonneurOrdre",
      optionLabelKey: "libelleDonneurOrdre",
      url: REST_API_URL + "/donneurordres/",
      rowIdx: 3
    },{
      title: "Responsable",
      type: "combo",
      name: "idResponsable",
      optionValueKey: "idResponsable",
      optionLabelKey: "libelleResponsable",
      url: REST_API_URL + "/responsables/",
      rowIdx: 3
    }];
  }

}
export default ObjectifList;



// WEBPACK FOOTER //
// ./src/views/Search/ObjectifList.js